import { Component, inject, OnInit } from "@angular/core";
import { SettingsService } from "../../../../../../services/settings.service";
import { CardVariant } from "../../../../../../shared/components/dashboard/summary-cards-variant/summary-cards-variant.component";
import {
  faDroplet,
  faTemperatureEmpty,
} from "@fortawesome/free-solid-svg-icons";
import { Observable } from "rxjs";
import { LayoutService } from "../../../../../../shared/components/app-layout/shared-layout/layout.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../../store";
import { ActivatedRoute } from "@angular/router";
import { StoreItemActions } from "../../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../../store/entities/store-item/store-item.model";
import { GET_WAREHOUSE_BUILDINGS } from "../../../../../../store/entities/warehouse-management/building/building.graphql";
import { selectStoreItems } from "../../../../../../store/entities/store-item/store-item.selectors";
import {
  GET_HUMIDITY_GRAPH_DATA,
  GET_TEMPERATURE_GRAPH_DATA
} from "../../../../../../store/entities/shared/temp-humidity-graph/temp-humidity-graph.graphql";
import {GraphqlService} from "../../../../../../services/graphql.service";
import {Building} from "../../../../../../store/entities/warehouse-management/building/building.model";

@Component({
  selector: "app-warehouse-building-view",
  templateUrl: "./warehouse-building-view.component.html",
  styleUrl: "./warehouse-building-view.component.scss",
})
export class WarehouseBuildingViewComponent implements OnInit {
  private settingService: SettingsService = inject(SettingsService);
  private layoutService: LayoutService = inject(LayoutService);
  private apollo: GraphqlService = inject(GraphqlService);
  public serviceUsage!: any[];
  public tempLineChartsData: any[];
  public humLineChartsData: any[];
  public xAxis = [];

  constructor(private store: Store<AppState>, private route: ActivatedRoute) {}

  loadingData: boolean = false
  title;
  addPermission: string[] = ["NO_PERMISSION"];
  cards: CardVariant[] = [
    {
      title: "Average Temperature",
      icon: faTemperatureEmpty,
      classes: "text-amber-500 bg-amber-50/60",
      value: this.settingService.formatDegrees("10"),
    },
    {
      title: "Average Humidity",
      icon: faDroplet,
      classes: "text-blue-500 bg-blue-50/60",
      value: "10%",
    },
  ];
  selectedTimeRange: string = 'day';
  showChart: boolean = false;
  heatmapTabs: { name: string; slug: "temperature" | "humidity" }[] = [
    { name: "Temperature Heatmap", slug: "temperature" },
    { name: "Humidity Heatmap", slug: "humidity" },
  ];
  activeSlug: "temperature" | "humidity" = "temperature";
  lineChartsTabs: { name: string; slug: "lineChartsTemp" | "lineChartsHum" }[] = [
    { name: "Temperature LineGraph", slug: "lineChartsTemp" },
    { name: "Humidity LineGraph", slug: "lineChartsHum" },
  ];
  activeSlugLineCharts: "lineChartsTemp" | "lineChartsHum" = "lineChartsTemp";
  currentTime: string;
  sixHoursPast: string;
  temperatureHeatmapData: any[];
  humidityHeatmapData: any[];
  heatmapXAxis: string[];
  id
  data: Building[];
  async ngOnInit() {
    this.id = this.route.snapshot.params['uniqueId'] ?? null;
    this.setCurrentTime();
    this.setSixHoursPastTime();

    this.store.dispatch(
      StoreItemActions.getStoreItems({
        entity: StoreItemEntity.buildings,
        query: GET_WAREHOUSE_BUILDINGS,
        filtering: { uniqueId: this.id, pageNumber: 1 },

      })
    );
    this.store
      .select(selectStoreItems(StoreItemEntity.buildings))
      .subscribe((res:Building[]) => {
        this.data = res
      });

    this.title = "Warehouse Building Details";
    await this.fetchGraphData();

    this.temperatureHeatmapData = [
      {
        name: "Zone A",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone B",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone C",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone D",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone E",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone F",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone G",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone H",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone I",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
    ];
    this.humidityHeatmapData = [
      {
        name: "Zone A",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone B",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone C",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone D",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone E",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone F",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone G",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone H",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
      {
        name: "Zone I",
        data: this.generateData(18, {
          min: 0,
          max: 90,
        }),
      },
    ];
    this.heatmapXAxis = [
      "Sensor A",
      "Sensor B",
      "Sensor C",
      "Sensor D",
      "Sensor E",
      "Sensor F",
      "Sensor G",
      "Sensor H",
      "Sensor I",
      "Sensor J",
      "Sensor K",
      "Sensor L",
      "Sensor M",
      "Sensor N",
      "Sensor O",
      "Sensor P",
      "Sensor Q",
      "Sensor R",
    ];


    this.serviceUsage = [
      {
        name: "Temperature",
        data: 78,
        color: "#FD9034",
      },
    ];

    setTimeout(() => {
      this.showChart = true;
    }, 1000);
  }
  async fetchGraphData(): Promise<void> {
    this.loadingData = true
    this.tempLineChartsData = [];
    this.humLineChartsData = [];
    this.xAxis = [];

    const query =
        this.activeSlugLineCharts === "lineChartsTemp"
            ? GET_TEMPERATURE_GRAPH_DATA
            : GET_HUMIDITY_GRAPH_DATA;

    const response: any = await this.apollo.query({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          startDate:this.sixHoursPast,
          endDate: this.currentTime,} },
    });

    const result = response.data[
        this.activeSlugLineCharts === "lineChartsTemp"
            ? "getTemperatureGraphData"
            : "getHumidityGraphData"
        ];

    if (result?.response?.status) {
      const data = result.data;

      this.updateXAxis(data);

      if (this.activeSlugLineCharts === "lineChartsTemp") {
        this.tempLineChartsData = [
          {
            name: "Temperature",
            data: data.map((reading) =>
                parseFloat(reading.temperature).toFixed(2)
            ),
            color: "#23AFF1",
          },
        ];
      } else {
        this.humLineChartsData = [
          {
            name: "Humidity",
            data: data.map((reading) =>
                parseFloat(reading.humidity).toFixed(2)
            ),
            color: "#151C51",
          },
        ];
      }

    }
    this.loadingData = false
  }
  async onTimeChange() {
    await this.fetchGraphData();
  }
  async onTabChange(slug: "lineChartsTemp" | "lineChartsHum") {
    this.activeSlugLineCharts = slug;
    this.showChart = false; // Hide chart during data update
    await this.fetchGraphData();
  }

  setCurrentTime() {
    const now = new Date();
    this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
  }
  setSixHoursPastTime() {
    const now = new Date();
    now.setHours(now.getHours() - 6);
    this.sixHoursPast = this.settingService.formatDateForDateTimeLocal(now);
  }
  generateData(count: number, range: { min: number; max: number }): number[] {
    const { min, max } = range;
    const data: number[] = [];

    for (let i = 0; i < count; i++) {
      const randomValue = Math.floor(Math.random() * (max - min + 1)) + min;
      data.push(randomValue);
    }

    return data;
  }
  closePanel(shouldUpdate = false) {
    this.layoutService.closePanel();
  }
  updateXAxis(readings: any[]): void {
    switch (this.selectedTimeRange) {
      case 'hour':
        this.xAxis = readings.map((reading) => {
              const date = new Date(reading.timestamp);
              return date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              });
            }
        );
        break;
      case 'day':
        this.xAxis = readings.map((reading) => {
              const date = new Date(reading.timestamp);
              return date.toLocaleTimeString([], {
                weekday: 'short',
              });
            }
        );
        break;
      case 'week':
        this.xAxis = readings.map((reading) => {
              const date = new Date(reading.timestamp);
              return `Week ${this.settingService.getWeekNumber(date)}`
            }
        );
        break;
      case 'month':
        this.xAxis = readings.map((reading) => {
              const date = new Date(reading.timestamp);
              return date.toLocaleTimeString([], {
                month: 'short',
              });
            }
        );
        break;
      case 'year':
        this.xAxis = readings.map((reading) => {
              const date = new Date(reading.timestamp)
              return date.getFullYear().toString()
            }
        );
        break;
    }
  }
}
